import { CurriedFn } from 'src/sdk/types';


const promiseTry: CurriedFn = (fn)  => {
  return Promise.resolve(fn())
}

export default promiseTry
